import styled from 'styled-components'

export const InfoContainer = styled.div`
    color: #fff;
    background: #03171d;
    padding: 100px 0;
`
export const InfoContainer2 = styled.div`
    color: #fff;
    background: #f0e0ce;
    padding: 100px 0;
`

export const InfoWrapper = styled.div`
    display: grid;
    z-index: 1;
    height; 860px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;
`

export const InfoRow = styled.div`
    display: grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    grid-template-areas: ${({imgStart}) => (imgStart ? `'col2 col1'` : `'col1 col2'` )};

    @media screen and (max-width: 768px) {
        grid-template-areas: ${({imgStart}) => (imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`)}
    }
`

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`

export const Column2 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col2;
`
export const Column3 = styled.div`
    margin-bottom: 15px;
    grid-area: col1;
`

export const TextWrapper = styled.div`
    max-width: 400px;
    padding-top: 0;
    padding-bottom: 60px; 
`
export const TextWrapper2 = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px; 
    padding-left: 70px;

    @media screen and (max-width: 768px){
        padding-top: 50px;
        padding-left: 10px;
        align-items: center;
    }
`
export const TopLine = styled.p`
    color: #fff !important;
    font-size: 50px;
    font-weight: 300;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 30px;
    margin-left: -4px;
`
export const Heading = styled.h1`
    color: #fff;
    margin-bottom: 24px;
    font-weight: 200px;
    font-size: 48px;
    line-height: 1.1;

    @media screen and (max-width: 480px){
        font-size: 32px;
    }
`
export const Heading2 = styled.h1`
    color: #000 !important;
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;

    @media screen and (max-width: 480px){
        font-size: 32px;
    }
`
export const Subtitle = styled.p`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 24px;
    color: #010606';
`
export const Subtitle2 = styled.p`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 24px;
    color: #000 !important;
`
export const ImgWrap = styled.div`
    max-width: 555px;
    height: 100%;
`
export const Img = styled.img`
    width: 90%;
    height: 630px;
    border-radius: 20px;

    @media screen and (max-width: 768px){
        width: 100%;
        height: 450px;
    }
`